import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/styles/common.css'
import './permission'
import zongzhi from './plugins/zongzhi'
Vue.use(zongzhi)
import icon from './plugins/icon'
Vue.use(icon)
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
// process.env.NODE_ENV === 'development' && require('@/mock')
require('@/mock')

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import jquery from "jquery"
Vue.prototype.$=jquery;


import  'alertifyjs/build/css/alertify.min.css'
import  'alertifyjs/build/css/themes/default.min.css'

Vue.config.productionTip = false


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
